import axios from 'axios';
import store from '../store';
import verifyAuth from '../services/utilities' 

class JournalRepository {

    constructor(){
        this.basePath = store.state.backend;
    }

    allTradesOfUser(pageableParams) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/trades/user`, {headers: headers, params: pageableParams});
        response = verifyAuth(response) 
        return response;
    }

    allTradesOfExternalUser(userId, pageableParams) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/trades/user/external?userId=${userId}`, {headers: headers, params: pageableParams});
        response = verifyAuth(response) 
        return response;
    }

    filteredTradesOfUser(filter, pageableParams) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/trades/filter` ,filter, {headers: headers, params: pageableParams});
        response = verifyAuth(response) 
        return response;
    }
    filteredTradesOfUserGet(filter) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/trades/filter`, {headers: headers, params:filter});
        response = verifyAuth(response) 
        return response;
    }

    filteredTradesOfExternalUser(filter, pageableParams) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/trades/filter/external` ,filter, {headers: headers, params: pageableParams});
        response = verifyAuth(response) 
        return response;
    }
    filteredTradesOfExternalUserGet(filter) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/trades/filter/external`, {headers: headers, params:filter});
        response = verifyAuth(response) 
        return response;
    }

    createTrade(trade) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/trades`, trade, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    updateTrade(trade) {
        let headers = {'Authorization': store.state.token};
        let response = axios.put(`${this.basePath}/ext/trades`, trade, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    deleteTrade(tradeId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.delete(`${this.basePath}/ext/trades/${tradeId}`, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    deleteMultipleTrades(trades) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/trades/multiple`, trades, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    updateTradeNote(tradeId, tradeNote) {
        let headers = {'Authorization': store.state.token};
        let data = {
            tradeId: tradeId,
            tradeNote: tradeNote,
        };
        let response = axios.post(`${this.basePath}/ext/trades/note`, data, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    importTrades(trades) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/trades/add-by-import`, trades, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    analyticsSummary(filter) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/trades/analytics`, filter, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    analyticsSummaryOfExternalUser(filter) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/trades/analytics/external`, filter, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    updateTradeImage(data) {
        let headers = {'Authorization': store.state.token};
        let response = axios.put(`${this.basePath}/ext/trades/trade-image/${data.trade.id}`,data.formData, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    getTradeImage(key){
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/trades/trade-image/${key}`,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }
}

export default new JournalRepository();
